import React from 'react'

import { useLogEvent } from '~/hooks/useLogEvent'
import { exists } from '~/utils'

export type ManualLinkProps = {
  href: string
  children: React.ReactNode
  className?: string
  logEventName?: string
}

// マニュアル（WordPress上のドキュメント）を新しいタブで開くリンク。
// 箇所ごとに遷移先が異なるため、href は呼び出し側で指定する。
export const ManualLink = ({
  children,
  className,
  href,
  logEventName,
}: ManualLinkProps) => {
  const logEvent = useLogEvent()
  const handleClick = React.useCallback(() => {
    if (exists(logEventName)) {
      logEvent(logEventName)
    }
  }, [logEvent, logEventName])

  return (
    <a
      className={className}
      href={href}
      rel="noopener noreferrer"
      target="_blank"
      onClick={handleClick}
    >
      {children}
    </a>
  )
}
